import { Dialog, Box, Typography, Button, CircularProgress } from '@mui/material';
import { DeleteConfirmDialogProps } from './DeleteConfirmDialog.types';

/**
 * Delete confirmation dialog component for station deletion
 * Displays confirmation message with station details and action buttons
 *
 * Features:
 * - Confirmation message with station brand and address
 * - Cancel and delete buttons with loading states
 * - Prevents closing during deletion process
 * - Loading spinner on delete button during operation
 *
 * @param props - Component props containing dialog state and callbacks
 * @returns JSX element containing the delete confirmation dialog
 */
export function DeleteConfirmDialog({
  open,
  brand,
  address,
  deleting,
  onClose,
  onConfirm
}: DeleteConfirmDialogProps): JSX.Element {
  return (
    <Dialog open={open} onClose={() => !deleting && onClose()} maxWidth="sm" fullWidth>
      <Box className="station-profile-delete-confirm-dialog">
        <Typography variant="h6" className="station-profile-delete-confirm-title">
          Підтвердження видалення
        </Typography>
        <Typography className="station-profile-delete-confirm-text">
          Ви дійсно хочете видалити АЗК конкурента{' '}
          <strong>
            {brand} - {address}
          </strong>{' '}
          із бази даних?
        </Typography>
        <Box className="station-profile-delete-confirm-actions">
          <Button onClick={onClose} disabled={deleting} className="station-profile-delete-confirm-cancel">
            Скасувати
          </Button>
          <Button
            onClick={onConfirm}
            disabled={deleting}
            variant="contained"
            className="station-profile-delete-confirm-delete"
          >
            {deleting ? <CircularProgress size={20} sx={{ color: 'white' }} /> : 'Видалити'}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}
